export const SignalKinds = [
    {
        label: 'Signal',
        value: 'signal',
    },
    {
        label: 'Reference',
        value: 'reference',
    },
    {
        label: 'Solvent',
        value: 'solvent',
    },
    {
        label: 'Impurity',
        value: 'impurity',
    },
    {
        label: 'Standard',
        value: 'standard',
    },
    {
        label: 'P1',
        value: 'p1',
    },
    {
        label: 'P2',
        value: 'p2',
    },
    {
        label: 'P3',
        value: 'p3',
    },
];
export const SignalKindsToInclude = ['signal'];
export const DatumKind = { signal: 'signal', mixed: 'mixed' };
//# sourceMappingURL=SignalsKinds.js.map